<!--<div class="pagebrk">
  <printheaderview [hasimage]="1"></printheaderview>
  <div class="row">
    <div class="col-print-12 padding-left-0px">
      <div class="card">
        <div class="card-header padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px"></div>
        <div class="card-body padding-top-0px padding-bottom-0px font-weight-normal">

          <div class="row">
            <div class="col-print-11 text-align-center">
              <label class="margin-bottom-10px font-familyhead">Advance Receipt</label>
            </div>
          </div>

          <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
            <div class="row margin-left-0px margin-right-0px">
              <div class="col-print-6 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient Name:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-bold">

                    </label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Gender/Age:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
                  </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Patient ID:</label>
                  </div>
                  <div class="col-print-8">
                    <label class="margin-bottom-0px font-family float-left font-weight-normal">

                    </label>
                  </div>
                </div>

              </div>

              <div class="col-print-6 margin-top-10 margin-bottom-10px">
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Bill Date:</label>
                  </div>
                  <div class="col-print-8">
                    </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Bill No:</label>
                  </div>
                  <div class="col-print-8">
                     </div>
                </div>
                <div class="row margin-left-0px">
                  <div class="col-print-4">
                    <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                  </div>
                  <div class="col-print-8">
                    </div>
                </div>

              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-normal padding-right-10px">Received From </label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal padding-right-10px padding-left-10px"> the amount of INR: </label>
              <label class="margin-bottom-0px font-family float-left font-weight-bold border-bot-1px">10000,</label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal padding-right-10px padding-left-10px">as</label>
              <label class="margin-bottom-0px font-family float-left font-weight-bold border-bot-1px"> OP Advance </label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal padding-right-10px padding-left-10px">, giving him/her</label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal">this receipt for the same.</label>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <label class="margin-bottom-0px font-family font-weight-bold padding-right-10px">Total amount in words:</label>
              <label class="margin-bottom-0px font-family float-left font-weight-normal">(Rupees Two Thousand Only)</label>

            </div>
          </div>

          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-12">
                <label class="margin-bottom-0px font-family font-weight-normal">Payment Details:</label>
              </div>

            </div>
          </div>

          <div class="col-print-11">
            <div class="row margin-left-0px">
              <div class="col-print-12">
                <div class="table-component margin-bottom-0px border4">
                  <div class="table-responsive">
                    <table class="table table-striped margin-left-zero width-50-new">

                      <tr>
                        <th class="font-weight-normal padding-right-0px font-family td-padding-tb background-primary padding-top-2px padding-bottom-2px">
                          S.NO
                        </th>

                        <th class="font-weight-normal padding-left-0px td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Rec.No & Date
                        </th>

                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Pay Mode
                        </th>

                        <th class="font-weight-normal td-padding-tb background-primary padding-top-2px padding-bottom-2px font-family">
                          Paid Amount
                        </th>
                      </tr>

                      <tr>
                        <td class="font-family padding-right-0px font-weight-normal padding-top-2px padding-bottom-2px">1</td>
                        <td class="font-family padding-left-0px font-weight-normal padding-top-2px padding-bottom-2px">HL2-HL-REC17005423 & 28-Oct-2019</td>
                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">Cash</td>

                        <td class="font-family font-weight-normal padding-top-2px padding-bottom-2px">2,500.00</td>
                      </tr>


                    </table>

                  </div>
                </div>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-2">
                <label class="margin-bottom-0px font-family font-weight-normal"></label>
              </div>
              <div class="col-print-6">
                <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
              </div>
            </div>
          </div>
          <div class="col-print-12">
            <div class="row margin-left-0px">
              <div class="col-print-7">

              </div>
              <div class="col-print-4">
                <div class="row margin-left-0px">
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">Total Paid:</label>
                  </div>
                  <div class="col-print-6">
                    <label class="margin-bottom-0px font-family font-weight-normal">2500</label>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>

  <printopbillfooterview></printopbillfooterview>

  </div>-->

<div class="row" *ngIf="LaserPrint == 'true'">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">
        
      </div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead">Advance Receipt</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Receipt No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-bold">{{ReceiptFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BillDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Branch}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal">Doctor:</label>
                </div>
                <div class="col-print-8" *ngIf="BillData2">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal">{{BillData2.PrescriberName}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center">
                          #
                        </th>

                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Item Description
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Prescriber
                        </th>-->
                        <!--<th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-35px">
                          Qty
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Price
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Amount
                        </th>-->
                        <!--<th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Discount
                        </th>-->
                        <!--<th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Tax
                        </th>-->
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Net
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.ItemDescription}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.PrescriberName}}</td>-->
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.Quantity}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.UnitPrice | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.ItemTotal | number:'1.2-2'}}</td>-->
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.Discount | number:'1.2-2'}}</td>-->
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.2-2'}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-7 float-right">
              <label class="margin-bottom-0px font-family font-weight-bold float-right">Bill Summary:</label>
            </div>
            <div class="col-print-1">

            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Grand Total:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{GrandTotal}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Discount:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Discount}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Tax:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Tax}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Net:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Net}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Bill Summary:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          Grand Total
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Discount
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Tax
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Net
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Due
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{GrandTotal | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{Discount | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{Tax | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{Net | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{Due | number:'1.2-2'}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Payment Details:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-left">
                          #
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Rec.No
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Pay Mode
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family">
                          Amount
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Details
                        </th>-->

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillReceiptsController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.ReceiptDate | date:'MMM-dd-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.FormattedCode}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.PaymentInstrument}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.AmountPaid | number:'1.2-2'}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.Remarks}}</td>-->

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal">Cashier:</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <!--<div class="col-print-1">
              <label class="margin-bottom-0px font-family font-weight-bold">(</label>
            </div>-->
            <div class="col-print-8" *ngIf="CurrentX_BillHeaderController">
              <label class="margin-bottom-0px font-family font-weight-normal">( {{CurrentX_BillHeaderController.PayeeName}} )</label>
            </div>
            <!--<div class="col-print-1">
              <label class="margin-bottom-0px font-family font-weight-bold">)</label>
            </div>-->
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Due:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Due}}</label>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>

<div class="row" *ngIf="DotMatrixPrint == 'true'">
  <div class="col-print-12 padding-left-0px">
    <div class="card">
      <div class="card-header background-color-wt padding-left-0px border-bottom-0 padding-top-0px padding-bottom-0px">

      </div>
      <div class="card-body padding-top-10px padding-bottom-0px font-weight-normal background-color-wt">

        <div class="row">
          <div class="col-print-12 text-align-center">
            <label class="font-familyhead" [style.font]="DmFont">Advance Receipt</label>
            <!--<qrcode class="padding-top-0px padding-bottom-0px qr-style7" [qrdata]="PatientId" [size]="90" [level]="'M'"></qrcode>-->
          </div>
        </div>

        <div class="col-print-12 bordertop border-bot-1px border-bottom-1px">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px" *ngIf="BillPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px  font-weight-normal" [style.font]="DmFont">Patient Name:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px  float-left font-weight-normal" [style.font]="DmFont">{{l.DisplayName}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="BillPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px  font-weight-normal" [style.font]="DmFont">ID:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px  float-left font-weight-normal" [style.font]="DmFont">{{l.FormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal" [style.font]="DmFont">Receipt No:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal" [style.font]="DmFont">{{ReceiptFormattedCode}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal" [style.font]="DmFont">Date:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal" [style.font]="DmFont">{{BillDate | date:'dd-MMM-yyyy'}}</label>
                </div>
              </div>
            </div>

            <div class="col-print-1"></div>

            <div class="col-print-5 margin-top-10 margin-bottom-10px">
              <div class="row margin-left-0px margin-right-0px" *ngIf="BillPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px  font-weight-normal" [style.font]="DmFont">Age / Gender:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px  float-left font-weight-normal" [style.font]="DmFont">{{l.Gender}}/{{l.Age}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px" *ngIf="BillPrintBodyWithPatientDetails == 'true'">
                <div class="col-print-4">
                  <label class="margin-bottom-0px  font-weight-normal" [style.font]="DmFont">Telephone:</label>
                </div>
                <div class="col-print-8" *ngFor="let l of CurrentPatientInfoByFormattedCodeController">
                  <label class="margin-bottom-0px  float-left font-weight-normal" [style.font]="DmFont">{{l.Telephone1}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal" [style.font]="DmFont">Branch:</label>
                </div>
                <div class="col-print-8">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal" [style.font]="DmFont">{{Branch}}</label>
                </div>
              </div>
              <div class="row margin-left-0px margin-right-0px">
                <div class="col-print-4">
                  <label class="margin-bottom-0px font-family font-weight-normal" [style.font]="DmFont">Doctor:</label>
                </div>
                <div class="col-print-8" *ngIf="BillData2">
                  <label class="margin-bottom-0px font-family float-left font-weight-normal" [style.font]="DmFont">{{BillData2.PrescriberName}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-center" [style.font]="DmFont">
                          #
                        </th>

                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family" [style.font]="DmFont">
                          Item Description
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Prescriber
                        </th>-->
                        <!--<th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-35px">
                          Qty
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Price
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Amount
                        </th>-->
                        <!--<th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Discount
                        </th>-->
                        <!--<th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50">
                          Tax
                        </th>-->
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family width-50" [style.font]="DmFont">
                          Net
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillItemsController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center" [style.font]="DmFont">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left" [style.font]="DmFont">{{l.ItemDescription}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{l.PrescriberName}}</td>-->
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.Quantity}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.UnitPrice | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.ItemTotal | number:'1.2-2'}}</td>-->
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-right">{{l.Discount | number:'1.2-2'}}</td>-->
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right" [style.font]="DmFont">{{(l.Quantity * l.UnitPrice)-(l.Quantity * l.UnitPrice * (l.Discount / 100)) | number:'1.2-2'}}</td>

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">

            <div class="col-print-7 float-right">
              <label class="margin-bottom-0px font-family font-weight-bold float-right">Bill Summary:</label>
            </div>
            <div class="col-print-1">

            </div>
            <div class="col-print-4">
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Grand Total:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{GrandTotal}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Discount:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Discount}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Tax:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Tax}}</label>
                </div>
              </div>
              <div class="row margin-left-0px">
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">Net:</label>
                </div>
                <div class="col-print-6">
                  <label class="margin-bottom-0px font-family font-weight-normal">{{Net}}</label>
                </div>
              </div>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-bold">Bill Summary:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family text-align-center">
                          Grand Total
                        </th>

                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Discount
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Tax
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Net
                        </th>
                        <th class="font-weight-normal background-primary text-align-center padding-top-2px padding-bottom-2px font-family">
                          Due
                        </th>

                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{GrandTotal | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{Discount | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{Tax | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{Net | number:'1.2-2'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-center">{{Due | number:'1.2-2'}}</td>
                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>-->
        <!--<div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>-->
        <div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family font-weight-normal" [style.font]="DmFont">Payment Details:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal" [style.font]="DmFont"></label>
            </div>
          </div>
        </div>

        <div class="col-print-12">
          <div class="row margin-right-0px margin-left-0px">
            <div class="col-print-12">
              <div class="table-component margin-bottom-0px border4">
                <div class="table-responsive">
                  <table class="table table-striped margin-left-zero">
                    <thead>
                      <tr>

                        <th class="font-weight-normal background-primary padding-top-2px padding-bottom-2px font-family width-35px text-align-left" [style.font]="DmFont">
                          #
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family" [style.font]="DmFont">
                          Date
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family" [style.font]="DmFont">
                          Rec.No
                        </th>
                        <th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family" [style.font]="DmFont">
                          Pay Mode
                        </th>
                        <th class="font-weight-normal background-primary text-align-right padding-top-2px padding-bottom-2px font-family" [style.font]="DmFont">
                          Amount
                        </th>
                        <!--<th class="font-weight-normal background-primary text-align-left padding-top-2px padding-bottom-2px font-family">
                          Details
                        </th>-->

                      </tr>
                    </thead>
                    <tbody>
                      <tr *ngFor="let l of CurrentX_BillReceiptsController;let RowIndex = index">
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left" [style.font]="DmFont">{{RowIndex+1}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left" [style.font]="DmFont">{{l.ReceiptDate | date:'MMM-dd-yyyy'}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left" [style.font]="DmFont">{{l.FormattedCode}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-left" [style.font]="DmFont">{{l.PaymentInstrument}}</td>
                        <td class="font-family padding-top-2px padding-bottom-2px text-align-right" [style.font]="DmFont">{{l.AmountPaid | number:'1.2-2'}}</td>
                        <!--<td class="font-family padding-top-2px padding-bottom-2px text-align-left">{{l.Remarks}}</td>-->

                      </tr>
                    </tbody>
                  </table>

                </div>
              </div>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal" [style.font]="DmFont">Cashier:</label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <div class="col-print-5">
              <label class="margin-bottom-0px font-family font-weight-normal"></label>
            </div>
            <div class="col-print-7">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <div class="col-print-12">
          <div class="row margin-left-0px">
            <!--<div class="col-print-1">
              <label class="margin-bottom-0px font-family font-weight-bold">(</label>
            </div>-->
            <div class="col-print-8" *ngIf="CurrentX_BillHeaderController">
              <label class="margin-bottom-0px font-family font-weight-normal" [style.font]="DmFont">( {{CurrentX_BillHeaderController.PayeeName}} )</label>
            </div>
            <!--<div class="col-print-1">
              <label class="margin-bottom-0px font-family font-weight-bold">)</label>
            </div>-->
            <div class="col-print-3">
              <label class="margin-bottom-0px font-family float-left font-weight-normal"></label>
            </div>
          </div>
        </div>
        <!--<div class="col-print-12">
          <div class="row margin-left-0px margin-right-0px">
            <div class="col-print-2">
              <label class="margin-bottom-0px font-family font-weight-bold">Due:</label>
            </div>
            <div class="col-print-6">
              <label class="margin-bottom-0px font-family float-left font-weight-normal">{{Due}}</label>
            </div>
          </div>
        </div>-->
      </div>
    </div>
  </div>
</div>
